import angular from 'angular';


(function () {
    'use strict';
    angular.module('app.core').factory('AnnouncementDA', AnnouncementDA);

    AnnouncementDA.$inject = ['CONF', 'Restangular','Country'];

    /* @ngInject */
    function AnnouncementDA(CONF,Restangular,Country) {
        var baseUrl = CONF.apiBaseUrl + '/v1/announcements';

        var exports = {
            createAnnouncement: createAnnouncement,
            getAllAnnouncements: getAllAnnouncements,
            getAnnouncement:getAnnouncement,
            deleteAnnouncement:deleteAnnouncement,
            updateAnnouncement:updateAnnouncement,
        };

        return exports;


        /**
         * Recherche d'audit.
         */
        function getAllAnnouncements(page = 0, size = 20)  {
            return Restangular.all(baseUrl)
                .one('search')
                .customGET('', {
                        page: page,
                        size: size
                    }
                )
                .then(data => {
                    return data;
                });
        }

        function updateAnnouncement(announcement) {
            return Restangular.all(baseUrl).customPUT(announcement);
        }

        function createAnnouncement(announcement) {
            return Restangular.all(baseUrl).post(announcement);
        }

        function getAnnouncement(id) {
            return Restangular.one(baseUrl + '/' + id)
                .get()
                .then(function (data) {
                    if(data.principals != null){
                        let mapedPrincipal =[]
                        angular.forEach(data.principals, function(principal) {
                            principal= Object.assign({}, principal, {eidWithId: principal.principalEid + ' (' + principal.principalAppId + ')'});
                            principal= Object.assign({}, principal, {text: principal.eidWithId});
                            mapedPrincipal.push(principal)
                        });
                        data.principals = mapedPrincipal
                    }
                    if (data.countries != null){
                        data.countries  = data.countries.map(function (country){
                            return new Country(country);
                        })
                    }
                    return data;
                });
        }

        function deleteAnnouncement(id) {
            return Restangular.one(baseUrl, id).remove();
        }
    }
})();
